import React from "react";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";

import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import classes from "./RosterTable.module.css";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const RosterTable = (props) => {
  const navigate = useNavigate();
  const SampleData = props.roster;
  console.log(SampleData);

  const navigateRosterHandler = (row) => {
    navigate(`/rosterSearch/null/${row.classRosterId}`);
  };
  return (
    <TableContainer className={classes.tableContainer}>
      <Table Header aria-label="sticky table">
        <TableHead>
          <TableRow sx={{ backgroundColor: "#cecece" }}>
            <TableCell sx={{ textAlign: "center" }}>Roster ID</TableCell>
            <TableCell sx={{ textAlign: "center" }}>Wave #</TableCell>
            <TableCell sx={{ textAlign: "center" }}>Trainee Status</TableCell>
            <TableCell sx={{ textAlign: "center" }}>Parent Client</TableCell>
            <TableCell sx={{ textAlign: "center" }}>Trainer Name</TableCell>
            <TableCell sx={{ textAlign: "center" }}>OG Name</TableCell>
            <TableCell sx={{ textAlign: "center" }}>Request Status</TableCell>
            <TableCell sx={{ textAlign: "center" }}>
              Tech Equipment Solution
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {SampleData.length > 0 &&
            SampleData.map((row, i) => {
              const rowKey = `${row.classRosterId}-${i}`;
              return (
                <TableRow key={rowKey}>
                  <TableCell sx={{ textAlign: "center" }}>
                    <p
                      onClick={(e) => navigateRosterHandler(row)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          navigateRosterHandler(row);
                        }
                      }}
                      className={classes.rosterIdClass}
                    >
                      {row.classRosterId}
                    </p>
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{row.wave}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    <p
                      className={
                        row.requestStatus === "Cancelled" ||
                        row.requestStatus === "On Hold" ||
                        row.requestStatus === "Closed"
                          ? "text-decoration-line-bulk-default"
                          : null
                      }
                    >
                      {row.traineeStatus}
                    </p>
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {row.parentClientName}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {row.trainerName}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {row.ogName}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {row.requestStatus}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {row.techEquipmentSolution}
                  </TableCell>
                </TableRow>
              );
            })}
          {SampleData.length === 0 && (
            <p className={`${classes.noData} text-center`}>No Data Available</p>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

RosterTable.propTypes = {
  roster: PropTypes.any,
};

export default RosterTable;
